import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

export function GetRegularExpresions() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_EmployeeRegularExpressions).then(response => {
            dispatch(global_error_handling(response)); 
           if(response !== null && response !== undefined)
            dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_REGULAREXPRESSION_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}